import { call, put } from 'redux-saga/effects';

import { apiGeneral, queryBuilder, notify } from 'services';
import { requestErrorHandler } from 'utils';
import { ListDatatableColumnConfigsActions } from 'store/ducks/settings/configs/list-datatable-column-configs';

export function* listDatatableColumnConfigsRequest() {
  try {
    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/datatable-column-configs`
    );

    const { columnConfigs } = responseBody;

    yield put(ListDatatableColumnConfigsActions.success(columnConfigs));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(ListDatatableColumnConfigsActions.failure(errorMessage));
  }
}
